import { buildWorkspaceAgentComposerPlainTextContent } from '~/components/v2/components/workspace/workspace-agent-panel/utils/buildWorkspaceAgentComposerPlainTextContent';
import { hasSendableWorkspaceAgentComposerContent } from '~/components/v2/components/workspace/workspace-agent-panel/utils/hasSendableWorkspaceAgentComposerContent';
import { type WorkspaceAgentComposerDoc } from '~/components/v2/components/workspace/workspace-agent-panel/utils/serializeWorkspaceAgentComposerContent';

type WorkspaceAgentMarketingComposerDraftChain = {
  focus: (position: 'end') => WorkspaceAgentMarketingComposerDraftChain;
  insertContent: (
    content: ReturnType<typeof buildWorkspaceAgentComposerPlainTextContent>,
  ) => WorkspaceAgentMarketingComposerDraftChain;
  run: () => boolean;
};

export type WorkspaceAgentMarketingComposerDraftEditor = WorkspaceAgentComposerDoc & {
  chain: () => WorkspaceAgentMarketingComposerDraftChain;
  getText: () => string;
};

const composerContainsMarketingPrompt = (
  editor: WorkspaceAgentMarketingComposerDraftEditor,
  prompt: string,
): boolean => {
  const normalizedPrompt = prompt.trim();

  if (!normalizedPrompt) {
    return false;
  }

  return editor.getText().includes(normalizedPrompt);
};

/**
 * Inserts a marketing deep-link prompt when the composer is still empty. Returns true when the
 * editor holds sendable content that includes the prompt (including when it was already present).
 */
export const applyWorkspaceAgentMarketingComposerDraft = ({
  editor,
  prompt,
}: {
  editor: WorkspaceAgentMarketingComposerDraftEditor;
  prompt: string;
}): boolean => {
  if (composerContainsMarketingPrompt(editor, prompt)) {
    return hasSendableWorkspaceAgentComposerContent(editor);
  }

  if (hasSendableWorkspaceAgentComposerContent(editor)) {
    return false;
  }

  const promptContent = buildWorkspaceAgentComposerPlainTextContent(prompt);

  editor.chain().focus('end').insertContent(promptContent).run();

  return hasSendableWorkspaceAgentComposerContent(editor) && composerContainsMarketingPrompt(editor, prompt);
};
